
<template>
    <div class="slidepreview">
        <hooper :settings='hooperSettings.main' ref="carousel" @slide="updateCarousel">
            <slide v-for="(slide, indx) in solutionList" :key="indx" :index="indx">
                {{ slide.title }}
            </slide>
        </hooper>
        <a class="hooper-prev" @click.prevent="slidePrev"></a>
        <a class="hooper-next" @click.prevent="slideNext"></a>
    </div>

</template>


<script>
    import {
        Hooper,
        Slide,
        Navigation as HooperNavigation
    } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default {
        name: "slidernav",
        props: ['curentSolution','curentEnvironment'],
        data () {
            return {
                carouselData: 0,
                hooperSettings: {
                    itemsToShow: 1,
                    centerMode: true,
                    infiniteScroll: true,
                    main: {
                        // infiniteScroll: true,
                        // initialSlide: 0,
                        // transition: 500,
                        // mouseDrag: false,
                        // shortDrag: false, // so it won't slide on mobile screen just by touching it
                        // wheelControl: false,
                    },
                }

            }
        },
        computed: {
            solutionList: function () {
                let sol = [];
                this.curentEnvironment.solutions.forEach((item, i) => {
                    sol.push(this.globalData.solutions[item.id])
                });
                return sol;
            }
        },
        watch: {
            'carouselData'() {
                this.$refs.carousel.slideTo(this.carouselData);
            },
            'curentSolution'(){
                this.curentEnvironment.solutions.forEach((item, i)=> {
                    if(item.id == this.curentSolution.id){
                        this.carouselData = i;
                    }
                });
            },
            'curentEnvironment'(){
                this.curentEnvironment.solutions.forEach((item, i)=> {
                    if(item.id == this.curentSolution.id){
                        this.carouselData = i;
                    }
                });
            }

        },
        mounted(){
            this.curentEnvironment.solutions.forEach((item, i)=> {
                if(item.id == this.curentSolution.id){
                    this.carouselData = i;
                }
            });
        },
        methods: {
            slidePrev() {
                this.$refs.carousel.slidePrev();
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            updateCarousel(payload) {
                this.carouselData = payload.currentSlide;
                if(this.curentEnvironment.solutions.length >= payload.currentSlide){
                    this.$emit('selectSlideSolution', this.curentEnvironment.solutions[this.carouselData].id);
                }
            }
        },
        components: {
            Hooper,
            Slide,
        }
    }
</script>